import React, { Component } from 'react';
import { connect } from 'react-redux';
import { dAPI } from 'appSrc/api';
import { DLTextField, Checkbox, PrimaryButton } from 'appSrc/components/UI';
import LoadingReplace from 'appSrc/components/Shards/Loading/LoadingReplace';
import AllProductsTable from './Table';
import { showModal, hideModal } from 'appSrc/redux/actions';
import NewProductModal from '../../Modals/Product/NewProductModal';
import { Link } from 'react-router-dom';
import style from './styles/style.module.css';

class AllProductsView extends Component {
    constructor( props ) {
        super( props );
        this.state = {
            fetching: true,
            products: [],
            searchValue: '',
            productQueryObject: {
                page: 1,
                limit: 10,
                sort: '-desireid',
                search: undefined,
            },
        };
    }
    componentDidMount() {
        this.loadProducts();
    }
    updateSearch = ( e, { value } ) => {
        this.setState( { searchValue: value } );
    }
    onSearchKeyDown = ( e ) => {
        if( e.keyCode == 13 ) {
            e.preventDefault();
            this.setState( ( prevState ) => {
                prevState.fetching = true;
                prevState.products = [];
                prevState.productQueryObject.page = 1;
                prevState.productQueryObject.search = this.state.searchValue || undefined;
                return prevState;
            } );
            this.loadProducts();
        }
    }
    onFilter = ( key, value ) => {
        this.setState( ( prevState ) => {
            prevState.fetching = true;
            prevState.products = [];
            prevState.productQueryObject.page = 1;
            prevState.productQueryObject[ key ] = value;
            return prevState;
        } );
        this.loadProducts();
    }
    onColumnSort = ( value ) => {
        if( this.state.productQueryObject.sort == value ) {
            value = `-${ value }`;
        }
        this.setState( ( prevState ) => {
            prevState.fetching = true;
            prevState.products = [];
            prevState.productQueryObject.page = 1;
            prevState.productQueryObject.sort = value;
            return prevState;
        } );
        this.loadProducts();
    }
    loadProducts = () => {
        return this.props.getProducts( this.state.productQueryObject )
        .then( ( products ) => {
            this.setState( ( prevState ) => {
                prevState.fetching= false,
                prevState.products = prevState.products.concat( products ),
                prevState.productQueryObject.page++;
                return prevState;
            } );
            return products;
        } );
    }
    productUpdated = ( index, product ) => {
        this.setState( ( altState ) => {
            altState.products[ index ] = product;
            altState.products = altState.products.slice( 0 );
            return altState;
        } );
    }

    openNewModal = () => {
        this.setState( { newModal: true } );
    }
    onNewModalClose = () => {
        this.setState( { newModal: false } );
    }
    onNewModalSubmit = ( newProduct ) => {
        this.setState( ( altState ) => {
            altState.products.unshift( newProduct );
            altState.products = altState.products.slice( 0 );
            altState.newModal = false;
            return altState;
        } );
    }

    render() {
        const { fetching, products, searchValue } = this.state;

        return (
            <section className={ style.page }>
                <div className={ style.head }>
                    <h2>Products</h2>
                    <div className={ style.controls }>
                        <DLTextField className={ style.searchBar }
                        placeholder='Search'
                        value={ searchValue }
                        onChange={ this.updateSearch }
                        onKeyDown={ this.onSearchKeyDown }
                        noError />
                        <PrimaryButton
                        label='+ Create Product'
                        style={ { width: '150px' } }
                        onClick={ this.openNewModal } />
                    </div>
                    <div className={ style.tabs }>
                        <Link to='/admin/products' className={ style.tabOption }
                        data-active={ true }>View All</Link>
                        <Link to='/admin/products/featured' className={ style.tabOption }>Featured Products</Link>
                    </div>
                </div>
                <div className={ style.body }>
                    <section className={ style.allList }>
                        <div className={ style.filters }>
                            <span style={ { marginRight: '20px' } }>Filter By</span>

                            <Checkbox label='Featured'
                            checked={ !!this.state.productQueryObject[ 'featured' ] }
                            onChange={ ( e, newValue ) => { this.onFilter( 'featured', newValue || undefined ); } }
                            style={ { marginRight: '20px' } } />
                        </div>
                        { fetching ?
                            <LoadingReplace />
                            :
                            <AllProductsTable
                            products={ products }
                            loadMore={ this.loadProducts }
                            onColumnSort={ this.onColumnSort }
                            currentSort={ this.state.productQueryObject.sort }
                            onProductUpdated={ this.productUpdated }
                            elementHeight={ 90 } />
                        }
                    </section>
                </div>
                { this.state.newModal &&
                    <NewProductModal closeModal={ this.onNewModalClose }
                    onSubmit={ this.onNewModalSubmit }/>
                }
            </section>
        );
    }
}

const mapDispatchToProps = ( dispatch ) => {
    return {
        showModal: ( modalName ) => {
            dispatch( showModal( modalName ) );
        },
        hideModal: ( modalName ) => {
            dispatch( hideModal( modalName ) );
        },
        getProducts: ( queryObject ) => {
            return dAPI.get( '/admin/desires', queryObject );
        },
    };
};

export default connect( null, mapDispatchToProps )( AllProductsView );
